import styled from 'styled-components';

const StyledIcon = styled.div<{ $icon: string }>`
	width: 60px;
	height: 60px;
	border-radius: 20px;
	background-image: url(${(props) => props.$icon});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	cursor: pointer;
`;

export { StyledIcon };
